import { BaseComponent } from '@/mainComponent/items/BaseComponent';

class BetController extends BaseComponent {
  private _isInitialization: boolean = false;
  constructor() {
    super();
    this.setView();
  }

  setView(): void {
    if (this._isInitialization) return;
    if (game.component.bet.options.prefabs.betButton) {
      game.component.bet.options.prefabs.betButton.children.push(this.getPrefabConfig());
      game.component.bet.createBets();
    } else this.createBets();
    this.updateBets();

    this._isInitialization = true;
  }
  createBets() {
    const grid = game.component.bet.betPopupGrid;
    const popup = game.component.bet.betPopup;

    if (!grid || !popup) return;

    game.utils.PIXIUtils.removeAllChildren(grid);
    game.component.bet.betButtons = [];
    game.component.bet.bets.forEach((bet, index) => {
      const oldBtn = game.component.bet._prefabs.BetButton();
      oldBtn.children.push(this.getPrefabConfig());
      const btn = game.builder.create(oldBtn);

      btn.on('clicked', () => game.component.bet.onBetClicked(btn, index));
      game.component.bet.betButtons.push(btn);

      btn.children.forEach((c: { cacheAsBitmap: boolean }) => (c.cacheAsBitmap = true));
      grid.addChild(btn);
    });

    game.component.bet.onChangeOrientation();
  }

  updateBets() {
    if (game.component.bet.betButtons.length) {
      game.component.bet.bets.forEach((bet, index) => {
        const button = game.component.bet.betButtons[index];

        let currentButtonBet = bet;
        if (game.store.currentServerMode?.[0]?.type === 'hotBet') {
            currentButtonBet *= game.store.currentServerMode[0].multiplier;
        }

        button.children.forEach((c: any) => (c.cacheAsBitmap = false));
        this.updateBetButtonLabels(button, currentButtonBet);
        button.children.forEach((c: any) => (c.cacheAsBitmap = true));
      });
    }
    game.component.bet.updateBets();
  }

  updateBetButtonLabels(button: any, bet: number) {
    const isBtnFs: boolean = this.store.promo.isProgressGameAchievement() && this.store.promo.isBetProperly(bet);
    const isBtnBG: boolean = this.store.promo.isProgressGameAchievementBG() && this.store.promo.isBetProperly(bet);
    const isBtnFSGame: boolean = this.store.promo.isProgressGameAchievementFS() && this.store.promo.isBetProperly(bet);
    const isBetTR: boolean = this.store.promo.isProgressTournament() && this.store.promo.isBetProperly(bet);
    const isBorderPrize = isBtnBG || isBtnFs || isBtnFSGame || isBetTR;

    const borderPromo = game.tree.findByName('bet.popup_container.border_promo', button.children);
    if (!borderPromo) return;
    borderPromo.options.visible = isBorderPrize;

    borderPromo.children.forEach((label: any) => {
      switch (label.name) {
        case 'bet.popup_container.border_promo.fs_label':
          label.options.visible = isBtnFs;
          break;
        case 'bet.popup_container.border_promo.bonus_label':
          label.options.visible = isBtnBG;
          break;
        case 'bet.popup_container.border_promo.fs_game_label':
          label.options.visible = isBtnFSGame;
          break;
        case 'bet.popup_container.border_promo.tournament_label':
          label.options.visible = isBetTR;
          break;
      }
    });
  }
  waitSpin() {
    this.setView();
  }

  getPrefabConfig(): any {
    return {
      type: 'Graphics',
      visible: false,
      name: 'bet.popup_container.border_promo',
      shape: 'roundedRect',
      backgroundAlpha: 0,
      borderWidth: 7,
      borderColor: '0x59cb00',
      borderAlpha: 1,
      width: 210,
      height: 70,
      radius: 22,
      mask: {
        type: 'Graphics',
        shape: 'roundedRect',
        width: 215,
        height: 75,
        radius: 20
      },
      children: [
        {
          type: 'Container',
          visible: false,
          name: 'bet.popup_container.border_promo.fs_label',
          children: [
            {
              type: 'Graphics',
              shape: 'roundedRect',
              backgroundAlpha: 1,
              backgroundColor: '0x59cb00',
              borderWidth: 0,
              borderColor: '0x00FF11',
              borderAlpha: 1,
              width: 210,
              height: 70,
              radius: 20,
              relativePosition: { x: 1, y: 0 },
              position: { x: 60, y: -14 },
              mask: {
                type: 'Graphics',
                shape: 'roundedRect',
                width: 50,
                height: 30,
                radius: 20,
                position: { x: -80, y: 20 }
              }
            },
            {
              type: 'Text',
              text: 'FS',
              style: {
                fontSize: 22,
                fill: '#ffffff',
                wordWrapWidth: 1200,
                fontFamily: 'myriadpro-bold'
              },
              position: { x: -22, y: 9 },
              relativePosition: { x: 1, y: 0 }
            }
          ]
        },
        {
          type: 'Container',
          visible: false,
          name: 'bet.popup_container.border_promo.bonus_label',
          children: [
            {
              type: 'Graphics',
              shape: 'roundedRect',
              backgroundAlpha: 1,
              backgroundColor: '0x59cb00',
              borderWidth: 0,
              borderColor: '0x00FF11',
              borderAlpha: 1,
              width: 210,
              height: 70,
              radius: 20,
              relativePosition: { x: 1, y: 0 },
              position: { x: 26, y: -14 },
              mask: {
                type: 'Graphics',
                shape: 'roundedRect',
                width: 80,
                height: 30,
                radius: 20,
                position: { x: -60, y: 20 }
              }
            },
            {
              type: 'Text',
              text: 'BONUS',
              style: {
                fontSize: 20,
                fill: '#ffffff',
                wordWrapWidth: 1200,
                fontFamily: 'myriadpro-bold'
              },
              position: { x: -38, y: 10 },
              relativePosition: { x: 1, y: 0 }
            }
          ]
        },
        {
          type: 'Container',
          visible: false,
          name: 'bet.popup_container.border_promo.fs_game_label',
          children: [
            {
              type: 'Graphics',
              shape: 'roundedRect',
              backgroundAlpha: 1,
              backgroundColor: '0x59cb00',
              borderWidth: 0,
              borderColor: '0x00FF11',
              borderAlpha: 1,
              width: 210,
              height: 70,
              radius: 10,
              relativePosition: { x: 1, y: 0 },
              position: { x: 16, y: -14 },
              mask: {
                type: 'Graphics',
                shape: 'roundedRect',
                width: 100,
                height: 30,
                radius: 20,
                position: { x: -60, y: 20 }
              }
            },
            {
              type: 'Text',
              text: 'FS GAME',
              style: {
                fontSize: 20,
                fill: '#ffffff',
                wordWrapWidth: 1200,
                fontFamily: 'myriadpro-bold'
              },
              position: { x: -45, y: 10 },
              relativePosition: { x: 1, y: 0 }
            }
          ]
        },
        {
          type: 'Container',
          visible: false,
          name: 'bet.popup_container.border_promo.tournament_label',
          children: [
            {
              type: 'Graphics',
              shape: 'roundedRect',
              backgroundAlpha: 1,
              backgroundColor: '0x59cb00',
              borderWidth: 0,
              borderColor: '0x00FF11',
              borderAlpha: 1,
              width: 130,
              height: 100,
              radius: 20,
              relativePosition: { x: 1, y: 0 },
              position: { x: 20, y: -14 },
              mask: {
                type: 'Graphics',
                shape: 'roundedRect',
                width: 45,
                height: 30,
                radius: 20,
                position: { x: -40, y: 22 }
              }
            },
            {
              type: 'Text',
              text: 'TR',
              style: {
                fontSize: 24,
                fill: '#ffffff',
                wordWrapWidth: 1200,
                fontFamily: 'myriadpro-bold'
              },
              position: { x: -22, y: 10 },
              relativePosition: { x: 1, y: 0 }
            }
          ]
        }
      ]
    };
  }
}

export { BetController };
